import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RequiredShipmentService {
    private readonly _openRequests = signal(0);
    readonly openRequests = this._openRequests.asReadonly();
    private readonly _lastOpenRequestSeen = signal(0);
    readonly lastOpenRequestSeen = this._lastOpenRequestSeen.asReadonly();
    requiredcycle =signal(false)

    requestOpen(): void {
        this._openRequests.update((v) => v + 1);
        this.requiredcycle.set(true)
    }

    requestClose(): void {
        this._lastOpenRequestSeen.set(this._openRequests());
        this.requiredcycle.set(false)
    }

    reset(): void {
        this._openRequests.set(0);
        this._lastOpenRequestSeen.set(0);
        this.requiredcycle.set(false)
    }
}